import MainLayout from '@/common/components/layouts/MainLayout';
import InitialVisitExpertEntryTabs from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/InitialVisitExpertEntryTabs';
import InitialVisitVehicleInformation from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/SubstitutionPartsCard/VehicleInformation';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="بازدید اولیه / کارشناسی" header="titleHeader">
      <InitialVisitExpert />
    </MainLayout>
  );
};
const InitialVisitExpert = () => {
  return (
    <Box pt={24}>
      <InitialVisitVehicleInformation />
      <InitialVisitExpertEntryTabs />
    </Box>
  );
};
